

import { HashRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Index from "./components/pages/Index.jsx";
import Test1 from "./components/pages/Test1.jsx"

export default function App() {
  return (
    <HashRouter>
      <Routes>
          <Route index element={<Index />} />
          <Route path="Test" element={<Test1 />} />
      </Routes>
    </HashRouter>
  );
}
